<template>
  <div v-show="isShow">
    <div class="sp-mask"></div>
    <div class="sp-panel">
      <div class="sp-title">
        <h1>(多途径点)路段共享</h1>
        <button @click="hidePanel">×</button>
      </div>
      <div class="sp-wrap">
        <div class="item">
          <p class="item-title"></p>
          <p
          id="startmsg"
            type=""
            class=""
          
          />
        </div>
        <div class="item">
          <p class="item-title">途径点</p>
          <div class="item-list">
            <input
              type="text"
              class="item-text"
              v-for="(item, index) in roadWaysData.ways"
              :key="index"
            
              :id="tjmsg"
            />
          </div>
        </div>
        <div class="item">
          <p class="item-title"></p>
          <p
          id="teminalmsg"
            type=""
            class=""
           
          />
        </div>
        <div class="item">
          <p class="item-title">留言</p>
          <input 
          id="leavemsg"
          type="text" class="item-text"  />
          <!--<input type="text" class="item-text" v-model="userMessage" />-->
        </div>
      </div>
      <div class="sp-footer">
        <div class="marked-opera">
          <!-- <button id="link-copy"><span></span> 复制标记链接</button>
          <button id="link-share"><span></span> 分享</button> -->
          <button id="marked-save" @click="handleSave">
            <span></span> 保存标记
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
import VueCookies from 'vue-cookies';//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
Vue.use(VueCookies);//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码代码新加代码新加代码


export default 
{
  props: ["roadWaysData"],
  data() {
    return {
      isShow: false,
      userMessage: "",
    };
  },
  methods: {
    showPanel() {
      this.isShow = true;
    },
    hidePanel() {
      this.isShow = false;
    },
    handleSave2() {
    //  alert(this.userMessage);
    },
    handleSave() {
      let _this = this;
      let algoroadList = this.roadWaysData;
    
     // let message = this.userMessage;
     
     var x = document.getElementsByClassName("item-text");
var i;
var message="";

for (i = 0; i < x.length; i++)
{
   message=message +x[i].value  +"▲";
}
message=message.replace("false▲","");
message=message.replace("▲▲","▲");
message=message.replace("false▲","");
message=message.replace("▲▲","▲");
message=message.substring(0, message.lastIndexOf('▲'));
message=message.slice(1);
//this.$cookies.set("leavemsg", message);//新加代码新加代码新加代码新加代码新加代码新加代码新加代码新加代码
window.sessionStorage.setItem("leavemsg", message);
//alert(message);
      this.$http
        .post("/service/addAlgoroad", {
          type: "algoroad",
          algoroadList,
          message,
        })
        .then(function (oRes) {
          oRes = oRes.data;
          var link = `http://map.ayane.io/?ms=${oRes.id}`;
          
          _this.hidePanel();
          _this.$emit("openCopyCard", link);
          //console.log(oRes);
          
          // oURI.value = `localhost:8080/?ms=${oRes.id}`;
          // document.body.appendChild(oURI);
          // oURI.select();
          // document.execCommand("Copy");
          // document.body.removeChild(oURI);
          // alert("复制成功");
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/ShareRoadWays.less";
</style>
